"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var GeneratorHelpers_1 = require("../utils/GeneratorHelpers");
var DID_1 = __importDefault(require("./DID"));
var utils_1 = require("../utils");
var Instantiable_abstract_1 = require("../Instantiable.abstract");
var OceanAgreementsConditions_1 = require("./OceanAgreementsConditions");
var OceanAgreements = (function (_super) {
    __extends(OceanAgreements, _super);
    function OceanAgreements() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OceanAgreements.getInstance = function (config) {
        return __awaiter(this, void 0, void 0, function () {
            var instance, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        instance = new OceanAgreements();
                        instance.setInstanceConfig(config);
                        _a = instance;
                        return [4, OceanAgreementsConditions_1.OceanAgreementsConditions.getInstance(config)];
                    case 1:
                        _a.conditions = _b.sent();
                        return [2, instance];
                }
            });
        });
    };
    OceanAgreements.prototype.prepare = function (did, index, consumer) {
        return __awaiter(this, void 0, void 0, function () {
            var d, ddo, agreementId, templateName, agreementConditionsIds, signature;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        d = DID_1.default.parse(did);
                        return [4, this.ocean.aquarius.retrieveDDO(d)];
                    case 1:
                        ddo = _a.sent();
                        agreementId = utils_1.zeroX(GeneratorHelpers_1.generateId());
                        templateName = ddo.findServiceByType('access').attributes
                            .serviceAgreementTemplate.contractName;
                        return [4, this.ocean.keeper
                                .getTemplateByName(templateName)
                                .getAgreementIdsFromDDO(agreementId, ddo, consumer.getId(), consumer.getId())];
                    case 2:
                        agreementConditionsIds = _a.sent();
                        return [4, this.ocean.utils.agreements.signServiceAgreement(ddo, index, agreementId, agreementConditionsIds, consumer)];
                    case 3:
                        signature = _a.sent();
                        return [2, { agreementId: agreementId, signature: signature }];
                }
            });
        });
    };
    OceanAgreements.prototype.send = function (did, agreementId, index, signature, consumer) {
        return __awaiter(this, void 0, void 0, function () {
            var result, _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4, this.ocean.brizo.initializeServiceAgreement(utils_1.didPrefixed(did), utils_1.zeroX(agreementId), index, utils_1.zeroX(signature), consumer.getId())];
                    case 1:
                        result = _c.sent();
                        if (!!result.ok) return [3, 3];
                        _a = Error.bind;
                        _b = 'Error on initialize agreement: ';
                        return [4, result.text()];
                    case 2: throw new (_a.apply(Error, [void 0, _b + (_c.sent())]))();
                    case 3: return [2];
                }
            });
        });
    };
    OceanAgreements.prototype.create = function (did, agreementId, index, signature, consumer, publisher) {
        return __awaiter(this, void 0, void 0, function () {
            var d, ddo, templateName;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        d = DID_1.default.parse(did);
                        return [4, this.ocean.aquarius.retrieveDDO(d)];
                    case 1:
                        ddo = _a.sent();
                        templateName = ddo.findServiceById(index).attributes
                            .serviceAgreementTemplate.contractName;
                        return [4, this.ocean.keeper
                                .getTemplateByName(templateName)
                                .createAgreementFromDDO(agreementId, ddo, consumer.getId(), publisher.getId())];
                    case 2:
                        _a.sent();
                        return [2, true];
                }
            });
        });
    };
    OceanAgreements.prototype.status = function (agreementId, extended) {
        if (extended === void 0) { extended = false; }
        return __awaiter(this, void 0, void 0, function () {
            var templateId, fullStatus, simpleStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4, this.ocean.keeper.agreementStoreManager.getAgreement(agreementId)];
                    case 1:
                        templateId = (_a.sent()).templateId;
                        return [4, this.ocean.keeper
                                .getTemplateByAddress(templateId)
                                .getAgreementStatus(agreementId)];
                    case 2:
                        fullStatus = _a.sent();
                        if (!fullStatus) {
                            return [2];
                        }
                        if (extended) {
                            return [2, fullStatus];
                        }
                        simpleStatus = {};
                        Object.entries(fullStatus).forEach(function (_a) {
                            var condition = _a[0], state = _a[1].state;
                            simpleStatus[condition] = state;
                        });
                        return [2, simpleStatus];
                }
            });
        });
    };
    return OceanAgreements;
}(Instantiable_abstract_1.Instantiable));
exports.OceanAgreements = OceanAgreements;
//# sourceMappingURL=OceanAgreements.js.map